<ul class="navigation-list" [class]="isCollapsed() ? 'navigation-list--collapsed' : '-ml-5 -mr-5'">
  <li>
    <hypecast-admin-navigation-link
      [isCollapsed]="isCollapsed()"
      displayName="Dashboard"
      icon="home"
      link="dashboard"
    />
  </li>
  <li>
    <hypecast-admin-navigation-link
      [isCollapsed]="isCollapsed()"
      displayName="Podcasts"
      icon="microphone"
      link="podcasts"
    />
  </li>
  @if (showMeetingEntry()) {
    <li>
      <hypecast-admin-navigation-link
        [isCollapsed]="isCollapsed()"
        [alsoActiveFor]="['video-editor', 'editor']"
        displayName="Studios"
        icon="record"
        link="studios"
      />
    </li>
  }
  @if (showAudioAiEntry()) {
    <li>
      <hypecast-admin-navigation-link
        [isCollapsed]="isCollapsed()"
        displayName="HypecastAI"
        icon="sparkles"
        link="audio-ai"
      />
    </li>
  }
  <li>
    <hypecast-admin-navigation-link
      [isCollapsed]="isCollapsed()"
      displayName="Analytics"
      icon="line_chart"
      link="analytics"
    />
  </li>
  @if (isAnyAdministrator()) {
    <li>
      <hypecast-admin-navigation-link [isCollapsed]="isCollapsed()" displayName="Groups" icon="group" link="groups" />
    </li>
  }
  @if (showAdminManagementEntry()) {
    <li>
      <hypecast-admin-navigation-link [isCollapsed]="isCollapsed()" displayName="Users" icon="person" link="users" />
    </li>
  }
  <li>
    <hypecast-admin-navigation-link
      [isCollapsed]="isCollapsed()"
      displayName="Audio Library"
      [externalLink]="true"
      icon="library_music"
      link="https://www.hypecast.one/audio-library"
    >
    </hypecast-admin-navigation-link>
  </li>
  @if (showAdminManagementEntry()) {
    <li>
      <hypecast-admin-navigation-link
        [isCollapsed]="isCollapsed()"
        displayName="Settings"
        icon="cog"
        link="settings/edit"
      />
    </li>
  }
  <li>
    <div class="navigation-divider bg-secondary-light-blue" [class.navigation-divider--collapsed]="isCollapsed()"></div>
  </li>
  <li data-write-action>
    <hypecast-admin-navigation-link
      [isCollapsed]="isCollapsed()"
      [noActiveHighlight]="true"
      displayName="New podcast"
      icon="microphone_plus"
      link="podcasts/create"
    />
  </li>
  @if (showAdminManagementEntry()) {
    <li data-write-action>
      <hypecast-admin-navigation-link
        [isCollapsed]="isCollapsed()"
        [noActiveHighlight]="true"
        displayName="Invite user"
        icon="person_plus"
        link="users/create"
      />
    </li>
  }
  @if (isAnyAdministrator()) {
    <li data-write-action>
      <hypecast-admin-navigation-link
        [isCollapsed]="isCollapsed()"
        [noActiveHighlight]="true"
        displayName="New group"
        icon="group_plus"
        link="groups/create"
      />
    </li>
  }
</ul>
